
import { useEffect, useState, useRef } from 'react';
import Alert from '@mui/material/Alert';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';

// @mui
import {
  Tooltip,
  Badge,
  // Grid,
  // Card,
  Table,
  // Stack,
  Paper,
  // Avatar,
  Button,
  // Popover,
  // Checkbox,
  TableRow,
  // MenuItem,
  TableBody,
  TableCell,
  // Container,
  // Typography,
  // IconButton,
  TableContainer,
  // TablePagination,
  TextField,
  TableHead,
  TableFooter,
} from '@mui/material';
import { id } from 'date-fns/locale';
import Swal from 'sweetalert2';
import AlertPage from "../pages/AlertPage";
import "./InsertAdvancessPopup.css";

// components
import Iconify from '../components/iconify';
import { variables } from '../Variables';
import { InsertDailyCrIn } from '../components/api/DailyAccountApiService';
import { DailyAccountUpdateData } from '../model/DailyAccountModel';

function InsertCrInPopup(props) {
  const [dailyCrIn, setdailyCrIn] = useState(props.dailyCrIn);
  const navigate = useNavigate();
  const current = new Date(props.date);
  // const [date, setdate] = useState(props.date);
  const datee = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;


  const [trid, settrid] = useState(props.trid);

  const [CrIn, setCrIn] = useState(0);

  const [CrInTxt, setCrInTxt] = useState('');


  const [SaveStatus, setSaveStatus] = useState(0);
  const [show, setShow] = useState(false);



  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Resetcontrol = (e) => {
    e.current.style.border = "none";
  }




  const insertToDB = async (SaveStatus) => {
    const response = {
      InsertDate: current,
      TRAN_ID: props.trid,
      Amount: CrIn,
      GivenBy: CrInTxt,
    };
    const data = DailyAccountUpdateData(response);
    const res = await InsertDailyCrIn(data);
    const result = res.data;
    if (Number(result.Status) === 100) {
      handleCloseModal(false);
      alert(result.StatusMessage);
      ClearAccountsData();
      props.updateDashboard(props.id);
    }
    else if (Number(result.Status) === -100) {
      handleCloseModal(false);
      alert('(-ve) acount. \nInserted Successfully!');
      ClearAccountsData();
      props.updateDashboard(props.id);
    }
    else if (Number(result.Status) === 200) {
      handleCloseModal(false);
      alert('(+ve) acount. \nInserted Successfully!');
      ClearAccountsData();
      props.updateDashboard(props.id);
    }
    else {
      Swal.fire({
        title: 'Are you sure?',
        text: "Save any way on -ve or +ve?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!'
      }).then((result) => {
        if (result.isConfirmed) {
          InsertCrInssData(1);
        }
      });
    }

    // Save it!
    // fetch(`${variables.API_URL}DailyAccounts/InsertDailyCrIn`, {
    //     method: 'POST',
    //     headers: {
    //       'Accept': 'application/json',
    //       'Content-Type': 'application/json'
    //     },
    //   body: JSON.stringify({
    //     InsertDate: current,
    //     TRAN_ID: props.trid,
    //     Amount: CrIn,          
    //     GivenBy: CrInTxt,         
    //     })
    //   })
    //     .then(res => {
    //       return res.json();
    //     })
    //     .then((result) => {

    //       // console.log(result);
    //       if (result.interactID === 100) {
    //         handleCloseModal(false);
    //         alert(result.message);
    //         ClearAccountsData();
    //         props.updateDashboard(props.id);
    //       }
    //       else if (result.interactID === -100) {
    //         handleCloseModal(false);
    //         alert('(-ve) acount. \nInserted Successfully!');
    //         ClearAccountsData();
    //         props.updateDashboard(props.id);
    //       }
    //       else if (result.interactID === 200) {
    //         handleCloseModal(false);
    //         alert('(+ve) acount. \nInserted Successfully!');
    //         ClearAccountsData();
    //         props.updateDashboard(props.id);
    //       }
    //       else {

    //         if (window.confirm(result.message)) {
    //           // Save it!
    //           console.log('Save any way on -ve or +ve');
    //           InsertCrInssData(1);
    //         } else {
    //           // Do nothing!
    //           console.log('Opt to crosscheck');
    //         }
    //         // alert(result.message);
    //         console.log('');
    //       }
    //       // alert('Account Saved!');
    //       //* alert(props.id);

    //     }, (error) => {
    //       alert(error);
    //     });
  }
  const InsertCrInssData = (SaveStatus) => {
    setShow(true);
    if ((CrIn > 0 && CrInTxt.trim() !== "")) {
      if (SaveStatus === 1) {
        insertToDB(SaveStatus);
      }
      else {
        Swal.fire({
          title: 'Are you sure?',
          text: "Do you want to save?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Save it!'
        }).then((result) => {
          if (result.isConfirmed) {
            insertToDB(0);
          }
        });
      }
    }
    else {
      alert("\"Both fields are required! ")
    }





  };
  const ClearAccountsData = () => {
    settrid(0);

    setCrIn(0);

    setCrInTxt('');

  };

  const handleCloseModal = (st) => {
    setShow(st)
  }

  return (
    <>
      {props.hide ? (
        <Tooltip title={props.crintxt} followCursor>
          {
            (props.crin === 0 && '0') ||
            <Badge color="warning" variant="dot">{props.crin}</Badge>
          }
        </Tooltip>
      ) : (

        <Button size="small" className='sml' onClick={handleShow} startIcon={<Iconify icon="eva:plus-fill" />}>
          {<Tooltip title={props.crintxt} followCursor>
            {
              (props.crin === 0 && '0') ||
              <Badge color="warning" variant="dot">{props.crin}</Badge>
            }
          </Tooltip>}
        </Button>
      )}
      {/*
      <button onClick={handleShow}  className="css-12vebo6-MuiButtonBase-root-MuiButton-root block m-2 bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded">
        Update
  </button> */}


      <Modal style={{ zIndex: 1100 }}
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>CrIn on -[{datee}]</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id='InserAccountsPopup' name='Edwit' onSubmit={(e) => {
            e.preventDefault();
            // console.log('Form Submited');
            InsertCrInssData(0);
            // console.log(props.id, name, role);

            // console.log(' after');

          }}>

            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead />
                <TableBody>
                  <TableRow>



                    <TableCell component="th" scope="row">
                      <TextField variant="standard" type="number" size="small" name="adv" label="CrIn Cash ₹ "
                        value={CrIn}
                        onChange={(e) => { setCrIn(e.target.value) }}


                      />
                    </TableCell>
                    <TableCell align="right">
                      <TextField variant="standard"
                        size="small" fullWidth name="advd" label="CrIn Desc.."
                        onChange={(e) => { setCrInTxt(e.target.value) }}
                        value={CrInTxt}
                      />
                    </TableCell>

                  </TableRow>

                </TableBody>
                <TableFooter />
              </Table>
            </TableContainer>

            <TextField variant="standard" multiline fullWidth size="small" label="CrIn Cash ₹ "
              value={props.crintxt}
            />

          </form>
        </Modal.Body>
        <Modal.Footer>

          <button onClick={handleClose} className="css-12vebo6-MuiButtonBase-root-MuiButton-root font-bold py-2 px-4">
            Close
          </button>

          <button onClick={handleClose} form='InserAccountsPopup' className="bt-green css-12vebo6-MuiButtonBase-root-MuiButton-root font-bold py-2 px-4">
            Add CrIn
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default InsertCrInPopup;